import request from "@/util/axios";
import store from "@/store";

export function api_get_order_type(orderId) {
  return request({
    method: "get",
    url: "/mall/wx/orders/get-order-type",
    params: { orderId: orderId },
  });
}

export function api_get_hot_movie_list() {
  const regionCode = store.getters.city_code + "00";

  return request({
    method: "post",
    url: "/mall/wx/movie/apiProxy/movie.hot.list",
    data: { method: "movie.hot.list", citycode: regionCode },
  });
}

export function api_get_user_cate_id_list() {
  return request({
    url: "/mall/wx/wx-user-get-cate-id-list",
  });
}

// 获取医院列表
export function api_get_hospital_list(pi = 1, ps = 10, searchKey, level, sort) {
  const regionCode = store.getters.city_code || 5101; // 默认成都 走账号密码登录过来有这情况
  const lat = sessionStorage.getItem("USER_CURRENT_POI_LAT");
  const lng = sessionStorage.getItem("USER_CURRENT_POI_LNG");
  return request({
    url: "/mall/wx/Goods/get-hospital-list",
    params: { cityCode: regionCode, pi, ps, lat, lng, searchKey, level, sort },
  });
}

export function api_get_scenic_spot_list(
  pi = 1,
  ps = 10,
  searchKey,
  level,
  distance,
  price,
  grade,
  brand_id,
  city_code
) {
  const regionCode = city_code || store.getters.city_code || 5101; // 默认成都 走账号密码登录过来有这情况
  const lat = sessionStorage.getItem("USER_CURRENT_POI_LAT") || "30.6209017";
  const lng = sessionStorage.getItem("USER_CURRENT_POI_LNG") || "104.0677860";

  return request({
    url: "/mall/wx/Goods/get-scenic-spot-list",
    params: {
      cityCode: regionCode,
      pi,
      ps,
      lat,
      lng,
      searchKey,
      level,
      distance,
      price,
      grade,
      brand_id,
    },
  });
}

// getCtripGoodsList
export function api_get_ctrip_goods_list(shopId) {
  return request({
    url: "/mall/wx/Goods/get-ctrip-goods-list",
    params: { shopId },
  });
}

export function api_get_ctrip_goods_stock(resId, goodsId, lyp_sn) {
  return request({
    url: "/mall/wx/Goods/get-ctrip-goods-stock",
    params: { resId, goodsId ,lyp_sn},
  });
}

export function api_ctrip_order_create_check(data) {
  return request({
    method: "post",
    url: "/mall/wx/orders/ctrip-order-create-check",
    data: data,
  });
}

export function api_get_schedule(orgId, packageId) {
  return request({
    url: "/mall/wx/Goods/get-schedule",
    params: { orgId, packageId },
  });
}

export function api_get_hospital_goods_list(shopId) {
  return request({
    url: "/mall/wx/Goods/get-hospital-goods-list",
    params: { shopId },
  });
}

export function api_get_hospital_top_list(pi = 1, ps = 8) {
  const regionCode = store.getters.city_code;
  return request({
    url: "/mall/wx/Goods/get-hospital-top-list",
    params: { cityCode: regionCode, pi, ps },
  });
}

// 获取医院详情 getBrandShopById
export function getHospitalDetail(id) {
  return request({
    url: "/mall/wx/Goods/get-brand-shop-by-id",
    params: { id },
  });
}

// 获取商品列表
export function getGoodsList(cateId, cateCode, keyword = "", pi = 1, ps = 10) {
  const regionCode = store.getters.city_code;
  return request({
    url: "/mall/wx/Goods/wx-get-goods-list?105",
    params: { cateId, cateCode, regionCode, pi, ps, keyword },
  });
}

/**
 * 根据参数查询商品列表
 * @param {object} params 查询参数
 * @param {string=} params.cateCode - 类别代码
 * @param {number=} params.cateId  - 类别编号
 * @param {string=} [params.regionCode=当前用户城市] 城市代码，必须参数
 * @param {string=} params.sortStr 字段排序字符串
 * @param {string=} params.tag 标签
 * @param {string=} params.keyword 商品名称关键字
 * @param {number=} params.isSearch 是否搜索
 * @param {number=} params.isTopic 是否专题商品
 * @param {number=} params.maxPrice 最大价格(单位：分）
 * @param {number=} params.minPrice 最低价格(单位：分）
 * @param {string=} params.brandIds 品牌编号，多个用逗号风格
 * @param {number=} params.brandId 品牌编号
 * @param {array<number>=} params.excludeCateIds 排除类别编号
 * @param {array<number>=} params.includeCateIds 包含类别编号
 * @param {number=} [params.pi=1] 分页索引
 * @param {number=} params.ps=10] 分页大小
 */
export function api_get_goods_list_by_params(params) {
  params.regionCode = store.getters.city_code || 5101; // 默认成都 走账号密码登录过来有这情况
  return request({
    url: "/mall/wx/Goods/wx-get-goods-list?133",
    params: params,
  });
}

export function get_goods_list_by_store_index(params) {
  params.regionCode = store.getters.city_code || 5101; // 默认成都 走账号密码登录过来有这情况
  return request({
    url: "/mall/wx/Goods/get-goods-list-by-store-index",
    params: params,
  });
}

/**
 *
 * @param regionCode
 * @param brandId
 * @param pi
 * @param ps
 * @returns {AxiosPromise}
 */
export function api_get_goods_list_by_brand_id(
  regionCode,
  brandId,
  cateId,
  pi = 1,
  ps = 10,
  keyword = ""
) {
  return request({
    url: "/mall/wx/Goods/wx-get-goods-list?156",
    params: { brandId, regionCode, pi, ps, cateId, keyword },
  });
}

export function api_get_act_page_by_id(id) {
  return request({
    url: "/mall/wx/Goods/get-act-page-by-id",
    params: { id },
  });
}

export function api_get_goods_list_by_tag(
  regionCode,
  tag,
  cateId,
  pi = 1,
  ps = 10
) {
  return request({
    url: "/mall/wx/Goods/wx-get-goods-list?170",
    params: { tag, regionCode, pi, ps, cateId },
  });
}

// 获取商品类别列表
export function api_get_goods_cate_list(
  parentId,
  cateCode = "",
  haveHotCate = 0
) {
  return request({
    url: "/mall/wx/Goods/get-goods-cate-list",
    params: { parentId, cateCode, haveHotCate },
  });
}

// 获取商品详情
export function api_get_goods_by_id(goodsId) {
  return request({
    url: "/mall/wx/Goods/get-goods-by-id",
    params: { goodsId },
  });
}

// 获取商品库存
export function getGoodsStockById(goodsId, quantity, addressId) {
  return request({
    url: "/mall/wx/Goods/get-jd-goods-stock",
    params: { goodsId, quantity, addressId },
  });
}

export function getJdVopGoodsStock(goodsId, quantity, addressId) {
  return request({
    url: "/mall/wx/Goods/get-jd-vop-goods-stock",
    params: { goodsId, quantity, addressId },
  });
}

// 获取商品详情
export function mall_wx_goods_get_movie_by_tradeno(tradeno) {
  return request({
    url: "/mall/wx/Goods/get-movie-by-tradeno",
    params: { tradeno },
  });
}

// 获取商品供应商信息
export function getSupplierByGoodsId(goodsId) {
  return request({
    url: "/mall/wx/Goods/getSupplierByGoodsId",
    params: { goodsId },
  });
}

export function mall_orders_get_order_goods_list(
  statusOrder,
  statusPay,
  pi = 1,
  ps = 10
) {
  return request({
    url: "/mall/wx/orders/get-order-goods-list",
    params: {
      statusOrder,
      statusPay,
      pi,
      ps,
      orderType: null /*用户端订单列表 不再区分类型*/,
      cateCode: null /* 用户端不再区分 */,
      goodsType: null /* 用户端不再区分 */,
    },
  });
}

export function getOrderMovieList(statusOrder, statusPay, pi = 1, ps = 10) {
  return request({
    url: "/mall/wx/orders/getOrderMovieList",
    params: { statusOrder, statusPay, pi, ps },
  });
}

export function getOrderTicketList(statusOrder, statusPay, pi = 1, ps = 10) {
  return request({
    url: "/mall/wx/orders/getOrderTicketList",
    params: { statusOrder, statusPay, pi, ps },
  });
}

export function api_orders_get_order_fee(newOrderDTO) {
  return request({
    url: "/mall/wx/orders/get-order-fee",
    method: "post",
    data: newOrderDTO,
  });
}

export function deleteOrder(orderId) {
  return request({
    url: "/mall/wx/orders/deleteOrder",
    params: { orderId },
  });
}

/**
 * 更新电子票使用状态
 * @param {number} orderTicketId 编号
 * @param {Boolean} status 状态
 * @returns {AxiosPromise}
 */
export function update_ticket_order_status(orderTicketId, status) {
  return request({
    url: "/mall/wx/orders/update-ticket-order-status",
    method: "get",
    params: { orderTicketId, status },
  });
}

export function mall_orders_create(newOrderDTO) {
  if (!newOrderDTO.cityCode) {
    newOrderDTO.cityCode = 5101; // 默认成都 走账号密码登录过来有这情况
  }

  return request({
    url: "/mall/wx/orders/create",
    method: "post",
    data: newOrderDTO,
  });
}

export function mall_orders_repay(orderId, pwd, platform = 'WEIXIN') {
  return request({
    url: "/mall/wx/orders/repay",
    params: { orderId, pwd, platform },
  });
}

export function orderPayVerify(orderId) {
  return request({
    url: "/mall/wx/orders/orderPayVerify",
    params: { orderId },
  });
}

export function wx_cancel_order(orderId) {
  return request({
    url: "/mall/wx/orders/wx-cancel-order",
    params: { orderId },
  });
}

export function mall_wx_orders_get_movie_service_fee(movieName, count) {
  return request({
    url: "/mall/wx/orders/get-movie-service-fee",
    params: { movieName, count },
  });
}

export function getExpressById(expressId) {
  return request({
    url: "/mall/wx/orders/get-express-by-id",
    params: { id: expressId },
  });
}

export function getBrandById(brandId) {
  return request({
    url: "/mall/wx/orders/get-brand-by-id",
    params: { id: brandId },
  });
}

export function mall_Goods_get_Ads_Images(adId) {
  return request({
    url: "/mall/wx/Goods/get-ad-images-by-id",
    params: { adId },
  });
}

export function get_topic_by_id(topicId) {
  return request({
    url: "/mall/wx/Goods/get-topic-by-id",
    params: { topicId },
  });
}

export function getMultipleGoods(pi = 1, ps = 10, cateName = "") {
  const regionCode = store.getters.city_code;
  return request({
    url: "/mall/wx/Goods/getMultipleGoods",
    params: { pi, ps, cateName, regionCode },
  });
}

export function getMultipleGoodsByPublic(
  pi = 1,
  ps = 10,
  cateName = "",
  multipleTopicId
) {
  return request({
    url: "/mall/wx/Goods/get-multiple-goods-by-public",
    params: { pi, ps, cateName, multipleTopicId },
  });
}

export function wx_get_goods_list_by_topic(
  topicId,
  cateName = [],
  pi = 1,
  ps = 10,
  keyWord = ""
) {
  const regionCode = store.getters.city_code || 5101; // 默认成都 走账号密码登录过来有这情况
  return request({
    url: "/mall/wx/Goods/wx-list-goods-by-topic",
    params: { topicId, pi, ps, cateName, regionCode, keyWord },
  });
}

export function api_get_brands_by_cate_id(
  cateId,
  goodsCount = 0,
  pi = 1,
  ps = 8
) {
  const regionCode = store.getters.city_code;
  return request({
    url: "/mall/wx/orders/get-brands-by-cate-id?436",
    params: { cateId, pi, ps, goodsCount, regionCode },
  }).then((res) => {
    return new Promise((resolve, reject) => {
      resolve(res);
    });
  });
}

export function api_get_brands_list_by_cate_id(cateId) {
  return request({
    url: "/mall/wx/orders/get-brands-list-by-cate-id",
    params: { cateId, pi: 1, ps: 1000 },
  });
}

export function api_get_cate_by_id(cateId) {
  return request({
    url: "/mall/wx/Goods/get-cate-by-id",
    params: { cateId },
  });
}

export function queryExpress100(com, num) {
  return request({
    url: "/mall/wx/orders/query-express-100",
    params: { com, num },
  });
}

/**
 * 获取订单和子订单详情
 * @param com
 * @param num
 * @returns {AxiosPromise}
 */
export function getOrderAndSubById(orderId) {
  return request({
    url: "/mall/wx/orders/get-order-and-sub-by-id",
    params: { orderId },
  });
}

/**
 * 获取订单详情
 * @param orderId
 * @returns {AxiosPromise}
 */
export function wx_get_goods_order_detail(orderId, from) {
  var lng = sessionStorage.getItem("USER_CURRENT_POI_LNG");
  var lat = sessionStorage.getItem("USER_CURRENT_POI_LAT");

  return request({
    url: "/mall/wx/orders/get-goods-order-detail",
    params: { orderId, from, lat, lng },
  });
}

/**
 * 获取当前用户的专题列表
 * @returns {AxiosPromise}
 */
export function mall_WxUser_get_TopicList_ByUser() {
  return request({
    url: "/mall/wx/wx-user-get-topic-list-by-user",
  });
}
